import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { RetentionDetailMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { useIntl } from 'umi';

const { pageable, scrollable } = Table.addons;

const TrendTable = (props: any) => {
  const {
    tableData = [],
    tableHeaderOptions,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    retentionMetricSource = 'appannie',
  } = props;

  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);

  const { currentSortValue, currentSortMetric, currentRatioType } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };
  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    setSortTableData(sortTable);
  };

  const isSensorTowerMonthly = retentionMetricSource === 'sensortower';

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    tableHeaderOptions?.forEach((t) => {
      metricCloums.push(
        RetentionDetailMetricColumn({
          dataSource: isSensorTowerMonthly ? 'sensortower' : 'appannie',
          title: t.title,
          svgIcon: isSensorTowerMonthly ? SensorTowerIcon : undefined,
          textContent: isSensorTowerMonthly ? (
            <span style={{ whiteSpace: 'pre-line' }}>
              {formatMessage(
                { id: 'dbi_retention_monthly_sensortower_dx_hover' },
                { metric: t?.key, day: t?.key?.replace(/^D/i, '') },
              )}
            </span>
          ) : (
            t?.textContent
          ),
          key: `${t.key}`,
          metricKey: t?.metricKey || t?.key,
          sortMetric: t.key,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          entityType,
          gameName,
          gameCover,
          dateType,
          startDate,
          endDate,
          onSortChage: handleSortChange,
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric,
            currentSortValue,
            dateType,
            onSortChage: handleSortChange,
            width: 180,
          }),
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            // pageSizeOptions: [5, 10, 15],
            pageSizeOptions: [10, 20, 30, 50, 100, 200],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
          scrollable({
            //   maxHeight: 580,
            // minWidth: 2500
            //     tHeaderList?.length > 3
            //       ? 220 * tHeaderList?.length + 300
            //       : 'auto',
          }),
        ]}
      />
    </>
  );
};

export default TrendTable;
